// 引入工具函数示例  import { isPwa } from "@/utils/tools";

/**
 * 判断是否pwa环境
 */
export function isPwa() {
  return ["fullscreen", "standalone", "minimal-ui"].some(
    displayMode =>
      window.matchMedia("(display-mode: " + displayMode + ")").matches
  );
}

/**
 * 判断是否http协议
 * @param {string} url
 */
export function isHttp(url) {
  return !~url.indexOf("http");
}

/**
 * 防抖
 * @param {Function} callback 回调函数
 * @param {number} delay 延迟毫秒数，默认为300毫秒
 */
export function debounce(callback, delay = 300) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, delay);
  };
}

/**
 * 节流
 * @param {Function} callback 回调函数
 * @param {number} wait 节流毫秒数，默认为300毫秒
 */
export function throttle(callback, wait = 300) {
  let pre = Date.now();
  return function (...args) {
    const now = Date.now();
    if (now - pre > wait) {
      callback.apply(this, args);
      pre = now;
    }
  };
}

/**
 * 判断是否是媒体查询
 */
export function isMedia(config) {
  const width = window.screen.width;

  console.log(width);
  if (width > 800) {
    return config["pc"];
  }
  return config["mobile"];
}

/**
 * 调起docx或者pdf
 */

export const getDoxcOrPdf = herf => {
  const tempwindow = window.open("_blank");
  const url = `${window.location.protocol}//${window.location.host}/static/${herf}`;
  console.log(url);
  tempwindow.location = url;
  // window.location.protocol +
  // "//" +
  // window.location.host +
  // `/static/${herf}`;
};


/**
 * 获取类型
 * author: xxk
 * @param value：值
 * @returns {Function|any|string}：构造函数或特殊值
 */
 export const getType = (value) => {
  // [object Name] -> Name
  const name = Object.prototype.toString.call(value).slice(8, -1);
  // null、undefined：返回自身
  // Reflect：name值在浏览器环境结果为Reflect，在node环境（webpack打包）为Object，统一处理
  if ([null, undefined, Reflect].includes(value)) {return value;}
  // eval操作返回构造函数或全局对象，eval失败返回字符串
  try {
    const Fn = eval(name);
    return Fn.constructor === Function ? value.constructor || Fn : Fn;
  } catch (e) {
    return name;
  }
}

/**
 * 判断是否属于指定类型
 * author: xxk
 * @param value：值
 * @param type：单个或多个类型
 * @returns {boolean}
 */
 export const isType = (value, type)=>{
  // 转换成数组再统一判断
  const types = (() => {
    if (getType(type) === Array) {return type;}
    if (getType(type) === Set) {return Array.from(type);}
    return [type];
  })();
  return types.includes(getType(value));
}

/**
 * 解构获取对象部分值。通过 keys 直接获取对应字段，通过 more 对象或方法对作特殊字段处理
 * author: xxk
 * @param source：数据源
 * @param keys {String|Array}：如 'a,b,c' 或 ['a','b','c']
 * @param {}：配置项
 *          ignore {Array}：排除值，默认为[]不排除，常用可传 [undefined]、[undefined,null] 等
 *          more {Function|Object}：更多处理
 *          keepDescriptor：是否使用描述对象赋值
 *          reg {String|RegExp} 字符串时的分隔规则，默认为 ','，常用可以传 /[,\n]/ 等
 * @returns {{}}
 */
export const getObjectValues = (source = {}, keys = '', {ignore = [], more = {}, keepDescriptor = false, reg = ','} = {})=>{
  let values = {};
  // keys转换成数组
  if (getType(keys) === Array) {
    keys = keys.filter(val => val);
  }
  if (getType(keys) === String) {
    keys = keys.split(reg).map(val => val.trim()).filter(val => val);
  }
  for (let key of keys) {
    // 判断使用描述对象赋值和普通情况的处理
    const descriptor = Object.getOwnPropertyDescriptor(source, key);
    if (keepDescriptor && descriptor) {
      Object.defineProperty(values, key, descriptor);
    } else {
      if (ignore.includes(source[key])) {continue;}
      values[key] = source[key];
    }
  }
  const moreValues = getType(more) === Function ? more(source) : more;
  Object.assign(values, moreValues);
  return values;
}

/**
 * 深度合并对象
 * author: xxk
 * @param target：目标
 * @param sources：数据源，一个或多个值
 * @returns {{}}
 */
 export const deepAssign = (target = {}, ...sources)=>{
  for (let source of sources) {
    for (let key of Object.keys(source)) {
      // 对象递归处理，其他直接赋值
      if (getType(target[key]) === Object) {
        target[key] = deepAssign(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  return target;
}
